import { dateWhenLeavingMonth } from '../features/month/monthModel';
import { monthOf, weekStartOf } from '@wiztime/core';
import { ViewKind, type RouteView } from '../hooks/useRouteView';

/**
 * The date the other views open on from the current view: the day view's own date, the week's
 * day the day view last showed (else today inside the week, else its first day), the month
 * grid's focused day (else that day again, else today in its month, else the 1st; 2026-10b
 * §9.6), or today where the view has no date (statistics, settings).
 */
export function viewDate(
  view: RouteView,
  today: string,
  monthFocusedDate: string | null,
  lastDayDate: string | null,
): string {
  if (view.kind === ViewKind.Week && view.date !== null) {
    if (lastDayDate !== null && weekStartOf(lastDayDate) === view.date) return lastDayDate;
    return weekStartOf(today) === view.date ? today : view.date;
  }
  if (view.kind === ViewKind.Month && view.date !== null) {
    const month = monthOf(view.date);
    // The grid's focused day first, then the day the day view last showed inside the month.
    const lastDayInMonth = lastDayDate !== null && monthOf(lastDayDate) === month ? lastDayDate : null;
    return dateWhenLeavingMonth(month, today, monthFocusedDate ?? lastDayInMonth);
  }
  return view.date ?? today;
}
